<template>
    <div
        class="expense__actions flex items-center flex-nowrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light"
    >
        <div class="flex justify-start content">
            <slot name="left"></slot>
        </div>
        <div class="flex justify-end content ml-4">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'action-bar'
}
</script>

<style scoped></style>
